import React from 'react';
import { connect } from 'react-redux';

import TimeSlider from '../components/timeSlider/TimeSlider';

function TimeSliderComponent(props) {
  return <TimeSlider {...props} />;
}

const mapStateToProps = state => ({
  time: state.clock.time,
  startTime: state.clock.startTime,
  stopTime: state.clock.stopTime,
});

const mapDispatchToProps = dispatch => ({
  setTime: time => {
    dispatch({ type: 'SET_TIME', time });
  },
  pause: () => {
    dispatch({ type: 'PUSH_PAUSE' });
  },
  resume: () => {
    dispatch({ type: 'POP_PAUSE' });
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(TimeSliderComponent);
